interface ExplainabilityPanelProps {
  text: string;
  expanded: boolean;
  onToggle: () => void;
}

const PANEL_BODY_ID = 'explain-panel-body';

export function ExplainabilityPanel({ text, expanded, onToggle }: ExplainabilityPanelProps) {
  return (
    <section className="explain-panel">
      <button
        type="button"
        className={`explain-panel__toggle${expanded ? ' explain-panel__toggle--expanded' : ''}`}
        onClick={onToggle}
        aria-expanded={expanded}
        aria-controls={PANEL_BODY_ID}
      >
        <span className="explain-panel__text">How I figured this out</span>
        <span className="explain-panel__chevron" aria-hidden>
          ›
        </span>
      </button>
      {expanded ? (
        <div id={PANEL_BODY_ID} className="explain-panel__body">
          {text}
        </div>
      ) : null}
    </section>
  );
}

